import { render } from "./DesktopIcons.vue?vue&type=template&id=f6f5de52"
import script from "./DesktopIcons.vue?vue&type=script&lang=js"
export * from "./DesktopIcons.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__